import React from "react";
import { Link } from "react-router-dom";
import "./HeaderMenuDefault7.css";

function HeaderMenuDefault7() {
  return (
    <Link to="/aquisition">
      <div className="menu-item-default-41">
        <div className="label-171 inter-medium-wild-sand-14px">Aquisition</div>
      </div>
    </Link>
  );
}

export default HeaderMenuDefault7;
